import {toast} from 'react-toastify'
import {getAllDataRooms} from '../modules/data-rooms/core/_requests'
import {useIntl} from 'react-intl'
import {useMoveToFolderData} from '../modules/data-rooms/core/FileToFolderAuth'
// import {roleValues} from '../../../src/app/core/_constants'
import {useAuth} from '../modules/auth'

const useAllDataRooms = () => {
  const {setdataRoomApiLoading, setAllRoomData, searchValue, dataRoomStatus, shareDrawer} =
    useMoveToFolderData()
  const {companyId} = useAuth()
  const {formatMessage} = useIntl()

  const getAllDataRoomsById = async () => {
    try {
      shareDrawer ? setdataRoomApiLoading(false) : setdataRoomApiLoading(true)
      // if (companyId && role && role !== roleValues.BILLING && role !== roleValues.CURATOR) {
      if (companyId) {
        const {
          data: {data, success, errors},
        } = await getAllDataRooms(+companyId, searchValue, dataRoomStatus)
        if (success) {
          setAllRoomData(data)
        } else {
          errors.forEach((error: string) => {
            toast.error(formatMessage({id: error}))
          })
        }
      }
    } catch (err) {
      console.log(err)
    } finally {
      setdataRoomApiLoading(false)
    }
  }

  return {getAllDataRoomsById}
}

export default useAllDataRooms
